import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  filesSelector,
  messageSelector,
  templateSelector,
} from "./store/selector";
import {
  clearAction,
  deleteFileAction,
  setFilesAction,
  setMessageAction,
  setTemplateAction,
  updateFileAction
} from "./store/actions";
import { EmailFile } from "./interface/emailFile";
import { EmailTemplate } from "../templates/interfaces/api/get-email-templates";
import { emailApiService } from "./services/api";

export function useEmailCore() {
  const dispatch = useDispatch();
  const files = useSelector(filesSelector);
  const message = useSelector(messageSelector);
  const template = useSelector(templateSelector);

  const setMessage = useCallback((message: string) => dispatch(setMessageAction({ message })), [
    dispatch,
  ]);

  const addFiles = useCallback((files: EmailFile[]) => dispatch(setFilesAction({ files })), [
    dispatch,
  ]);

  const updateFile = useCallback((file: EmailFile) => dispatch(updateFileAction({ file })), [
    dispatch,
  ]);

  const deleteFile = useCallback((id: string) => dispatch(deleteFileAction({ id })), [
    dispatch,
  ]);

  const setTemplate = useCallback(
    (template: EmailTemplate | null) => dispatch(setTemplateAction({ template })), 
    [dispatch]
  );

  const reset = useCallback(() => dispatch(clearAction()), [
    dispatch,
  ]);

  const postEmailTextEditorImage = useCallback(
    async (image: File) => {
      try {
        const { link } = await emailApiService.postEmailTextEditorImage(image);
        return { data: { link } };
      } catch (error: any) {
        console.error(error);
      }
    },
    []
  );

  return {
    files,
    template,
    message,
    addFiles,
    deleteFile,
    updateFile,
    reset,
    setTemplate,
    setMessage,
    postEmailTextEditorImage
  };
}
